export enum SubscriptionType {
  Trial = 0,
  Free = 1,
  Paid = 2,
}
